import React, { memo, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Callout } from '@node-space/ui-components'
import { FiatSendSteps } from 'types/walletActions'
import {
  AmplitudeEvent,
  AmplitudeEventAction,
  AmplitudeEventCategory,
} from 'utils/amplitude/amplitudeEvents'
import track from 'utils/tracker'
import { SourcePayWallet } from '../../Pay/types'
import { FIAT_SEND_ERRORS } from '../constants'

interface BeneficiaryFormCalloutProps {
  isInsufficientBalance: boolean
  isPayoutsSupported: boolean
  wallet: SourcePayWallet
}
const BeneficiaryFormCallout = ({
  isInsufficientBalance,
  isPayoutsSupported,
  wallet,
}: BeneficiaryFormCalloutProps) => {
  const { t } = useTranslation()

  return useMemo(() => {
    if (!wallet) return

    if (isInsufficientBalance && isPayoutsSupported) {
      track.Amp.track(AmplitudeEvent.FIAT_PAYOUT_ERROR, {
        category: AmplitudeEventCategory.MERCHANT_PORTAL,
        action: AmplitudeEventAction.ERROR,
        error: FIAT_SEND_ERRORS.INSUFFICIENT_BALANCE,
        step: FiatSendSteps.BENEFICIARY,
      })
      return (
        <Callout variant="error">
          {t('payInsufficient', { currencyCode: wallet?.currency })}
        </Callout>
      )
    }

    if (!isPayoutsSupported) {
      track.Amp.track(AmplitudeEvent.FIAT_PAYOUT_ERROR, {
        category: AmplitudeEventCategory.MERCHANT_PORTAL,
        action: AmplitudeEventAction.ERROR,
        error: FIAT_SEND_ERRORS.PAYMENT_NOT_SUPPORTED,
        step: FiatSendSteps.BENEFICIARY,
      })
      return <Callout variant="error">{t('payoutsNotSupported')}</Callout>
    }
  }, [wallet, isInsufficientBalance, isPayoutsSupported])
}

export default memo(BeneficiaryFormCallout)
